module.exports = __webpack_public_path__ + "static/glucoseLogo-07694153a8135ab2aa99def3a39feaaf.png";